module.exports = __webpack_public_path__ + "img/fa_get.b98ee21.png";